//设置商品列表
export const SET_PERSONAL_INFO = "SET_PERSONAL_INFO";
//获取商品列表
export const GET_PERSONAL_INFO = "GET_PERSONAL_INFO";

//设置结算信息
export const SET_BILLING_INFO = "SET_BILLING_INFO";
//获取结算信息
export const GET_BILLING_INFO = "GET_BILLING_INFO";

//设置企业信息
export const SET_COMPANY_INFO = "SET_COMPANY_INFO";
//获取企业信息
export const GET_COMPANY_INFO = "GET_COMPANY_INFO";

//设置法人信息
export const SET_CORPORATE_PERSON_INFO = "SET_CORPORATE_PERSON_INFO";
//获取法人信息
export const GET_CORPORATE_PERSON_INFO = "GET_CORPORATE_PERSON_INFO";

//修改企业法人信息
export const MODIFY_COMPANY_LEGAL_INFO = "MODIFY_COMPANY_LEGAL_INFO";

//撤销公司名称、企业信息、法人信息的变更
export const REVERT_COMPANY_INFO_MODIFY = "REVERT_COMPANY_INFO_MODIFY";

//设置退款信息
export const SET_REFUND_INFO = "SET_REFUND_INFO";
//获取退款信息
export const GET_REFUND_INFO = "GET_REFUND_INFO";
//获取单条退款信息详情
export const GET_REFUND_DETAIL = "GET_REFUND_DETAIL";
//提交退款信息
export const SUBMIT_REFUND_INFO = 'SUBMIT_REFUND_INFO';
//获取退款银行相关信息
export const GET_REFUND_BANK_INFO = "GET_REFUND_BANK_INFO";
//获取退款支行银行相关信息
export const GET_REFUND_BRANCH_BANK_INFO = "GET_REFUND_BRANCH_BANK_INFO";
//撤销退款信息
export const CANCEL_REFUND_INFO = "CANCEL_REFUND_INFO";
//删除退款信息
export const DELETE_REFUND_INFO = "DELETE_REFUND_INFO";

//设置服务商列表
export const SET_PARENT_COMPANY_LISTS = 'SET_PARENT_COMPANY_LISTS';
//获取服务商列表
export const GET_PARENT_COMPANY_LISTS = 'GET_PARENT_COMPANY_LISTS';

//设置服务商列表
export const SET_SUB_COMPANY_LISTS = 'SET_SUB_COMPANY_LISTS';
//获取服务商列表
export const GET_SUB_COMPANY_LISTS = 'GET_SUB_COMPANY_LISTS';

//设置根据营业执照查询的服务商
export const SET_PARENT_COMPANY_BY_SEARCH = 'SET_PARENT_COMPANY_BY_SEARCH';
//获取根据营业执照查询的服务商
export const GET_PARENT_COMPANY_BY_LICENCE = 'GET_PARENT_COMPANY_BY_LICENCE';

//设置增票资质
export const SET_VAT_INFO = "SET_VAT_INFO";
//获取增票资质
export const GET_VAT_INFO = "GET_VAT_INFO";
//设置增票资质详情
export const SET_VAT_DETAIL = "SET_VAT_DETAIL";
//获取增票资质详情
export const GET_VAT_DETAIL = "GET_VAT_DETAIL";
//获取公司名称和纳税人识别码(新增增票)
export const GET_AGENCY_INFO = "GET_AGENCY_INFO";
//设置公司名称和纳税人识别码
export const SET_AGENCY_INFO = "SET_AGENCY_INFO";

//获取收票地址列表
export const GET_DELIVERY_ADDRESS_LIST = "GET_DELIVERY_ADDRESS_LIST";
//获取收票地址详情
export const GET_DELIVERY_ADDRESS_DETAIL = "GET_DELIVERY_ADDRESS_DETAIL";
//提交收票地址信息
export const SUBMIT_DELIVERY_ADDRESS = "SUBMIT_DELIVERY_ADDRESS";
//撤销收票地址
export const CANCEL_DELIVERY_ADDRESS = "CANCEL_DELIVERY_ADDRESS";
//删除收票地址
export const DELETE_DELIVERY_ADDRESS = "DELETE_DELIVERY_ADDRESS";

//开通卖家
export const OPEN_SELLER = "OPEN_SELLER";
//获取卖家信息
export const GET_SELLER_INFO = "GET_SELLER_INFO";
//获取卖家已售品类列表
export const GET_SELLER_CATEGORY = "GET_SELLER_CATEGORY";
//卖家新增品类
export const SELLER_ADD_CATEGORY = "SELLER_ADD_CATEGORY";
//获取卖家证照信息
export const GET_SELLER_LINCENCE_INFO = "GET_SELLER_LINCENCE_INFO";
//获取卖家开通开通状态
export const GET_SELLER_OPEN_STATUS = "GET_SELLER_OPEN_STATUS";
//获取卖家一级品类
export const GET_SELLER_FIRST_CATEGORIES = "GET_SELLER_FIRST_CATEGORIES";
//设置卖家一级品类
export const SET_SELLER_FIRST_CATEGORIES = "SET_SELLER_FIRST_CATEGORIES";
//开通卖家选择的售卖品类
export const OPEN_SELLER_SELECTED_CATEGORIES = "OPEN_SELLER_SELECTED_CATEGORIES";

//获取公司信息中的私密信息
export const GET_COMPANY_SEC_INFO = "GET_COMPANY_SEC_INFO";
//获取渠道商信息中的安全信息
export const GET_GROUP_MEMBER_SEC_INFO = "GET_GROUP_MEMBER_SEC_INFO";
//换绑业务员
export const CHANGE_SALESMAN = 'CHANGE_SALESMAN'

//基础信息修改-获取手机号验证码
export const SEND_PHONE_VERIFICATION_CODE = 'SEND_PHONE_VERIFICATION_CODE'
//基础信息修改-绑定手机号
export const BIND_USER_PHONE = 'BIND_USER_PHONE'
//基础信息修改-保存其他信息(非手机号)
export const UPDATE_BUSINESS_USER_INFO = 'UPDATE_BUSINESS_USER_INFO'


// WEBPACK FOOTER //
// ./src/store/personal-center/type.js